window.Dashboard = window.Dashboard || {};
window.Dashboard.helpers = window.Dashboard.helpers || {};

class TimeHelper {
    timeUntil(date) {
        const now = new Date();
        const then = new Date(date);
        const nowUTC = new Date(now.toISOString());
        const thenUTC = new Date(then.toISOString());
        const diffInSeconds = Math.floor((thenUTC - nowUTC) / 1000);
        if (diffInSeconds < 0) {
            return "now";
        }
        const units = [
            {name: "year", seconds: 31536000},
            {name: "month", seconds: 2592000},
            {name: "day", seconds: 86400},
            {name: "hour", seconds: 3600},
            {name: "minute", seconds: 60},
            {name: "second", seconds: 1}
        ];
        for (const unit of units) {
            const count = Math.floor(diffInSeconds / unit.seconds);
            if (count >= 1) {
                return `in ${count} ${unit.name}${count > 1 ? "s" : ""}`;
            }
        }
        return "now";
    }

    timeSince(date) {
        const now = new Date();
        const then = new Date(date);
        const nowUTC = new Date(now.toISOString());
        const thenUTC = new Date(then.toISOString());
        const diffInSeconds = Math.floor((nowUTC - thenUTC) / 1000);
        if (diffInSeconds < 0) {
            return "now";
        }
        const units = [
            { name: "year", seconds: 31536000 },
            { name: "month", seconds: 2592000 },
            { name: "day", seconds: 86400 },
            { name: "hour", seconds: 3600 },
            { name: "minute", seconds: 60 },
            { name: "second", seconds: 1 }
        ];
        for (const unit of units) {
            const count = Math.floor(diffInSeconds / unit.seconds);
            if (count >= 1) {
                return `${count} ${unit.name}${count > 1 ? "s" : ""} ago`;
            }
        }
        return "now";
    }
}

window.Dashboard.helpers.time = new TimeHelper();
